import script from "./FittingApply.vue?vue&type=script&setup=true&lang=js"
export * from "./FittingApply.vue?vue&type=script&setup=true&lang=js"

import "./FittingApply.vue?vue&type=style&index=0&id=3d98124b&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d98124b"]])

export default __exports__